import React, { useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/about.css';

const JMS = () => {
  const underlineRef = useRef(null);

  useEffect(() => {
    const t = setTimeout(() => underlineRef.current && underlineRef.current.classList.add('animate'), 50);
    return () => clearTimeout(t);
  }, []);

  const detections = [
    { icon: 'bi bi-phone', color: '#dc3545', title: 'Phone Use While Driving', desc: 'Detects handheld phone use behind the wheel and flags it the moment it happens.' },
    { icon: 'bi bi-eye-slash', color: '#fd7e14', title: 'Distraction & Eyes Off Road', desc: 'Tracks gaze and head position to catch prolonged distraction from the road ahead.' },
    { icon: 'bi bi-emoji-dizzy', color: '#6f42c1', title: 'Drowsiness & Fatigue', desc: 'Recognises eye closure, yawning, and micro-sleep patterns that precede an incident.' },
    { icon: 'bi bi-shield-exclamation', color: '#0c61c0', title: 'Seatbelt & Compliance', desc: 'Verifies seatbelt use and other in-cab safety requirements on every journey.' },
    { icon: 'bi bi-speedometer', color: '#28a745', title: 'Unsafe Driving Behaviour', desc: 'Captures harsh braking, sharp cornering, tailgating, and speeding events.' },
    { icon: 'bi bi-camera-video', color: '#17a2b8', title: 'Event Video Capture', desc: 'Records a short clip of each violation so the event can be reviewed, not just reported.' },
  ];

  return (
    <>
      <div
        className="container-fluid about-bg d-flex align-items-end"
        style={{ minHeight: '85vh', padding: 0, top: '-122px', position: 'relative', overflow: 'hidden' }}
      >
        <div className="container about-content py-5" style={{ position: 'relative', zIndex: 4 }}>
          <div className="row">
            <div className="col-lg-8 col-md-10 col-12">
              <h1 className="about-title display-4 fw-bold" style={{ color: '#fff', textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
                JMS
              </h1>
              <h2 className="about-subtitle h4" style={{ color: '#e6f0ff', textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}>
                Journey Management System — AI Driver Monitoring
              </h2>
              <div className="about-underline mt-2" ref={underlineRef}></div>
            </div>
          </div>
        </div>
      </div>

      <section className="py-5 bg-white">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="card shadow-sm border-0 mb-5">
                <div className="card-body p-4 p-md-5">
                  <p className="mb-0">
                    JMS is an in-vehicle camera system that monitors driver behaviour in real time using AI models.
                    When a driver does something unsafe, JMS identifies exactly what the violation was, captures the
                    moment, and sends an instant notification to the person responsible — turning journey management
                    from a paper exercise into live, evidence-backed supervision.
                  </p>
                </div>
              </div>

              <h3 className="h4 fw-bold mb-4">What JMS Detects</h3>
              <div className="row g-4 mb-5">
                {detections.map((d) => (
                  <div className="col-md-6" key={d.title}>
                    <div className="card h-100 border-0 shadow-sm">
                      <div className="card-body p-4">
                        <i className={`${d.icon} fs-3`} style={{ color: d.color }}></i>
                        <h4 className="h6 fw-bold mt-3 mb-2">{d.title}</h4>
                        <p className="mb-0 text-muted">{d.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <h3 className="h4 fw-bold mb-4">How It Works</h3>
              <div className="card shadow-sm border-0">
                <div className="card-body p-4 p-md-5">
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item px-0">
                      <i className="bi bi-1-circle text-primary me-2"></i>
                      An in-cab camera is fitted to the vehicle and monitors the driver throughout the journey.
                    </li>
                    <li className="list-group-item px-0">
                      <i className="bi bi-2-circle text-primary me-2"></i>
                      AI models analyse the feed on the spot and classify any unsafe action as it occurs.
                    </li>
                    <li className="list-group-item px-0">
                      <i className="bi bi-3-circle text-primary me-2"></i>
                      The violation is identified by type and the moment is captured as photo and video evidence.
                    </li>
                    <li className="list-group-item px-0">
                      <i className="bi bi-4-circle text-primary me-2"></i>
                      A notification is sent immediately to the supervisor or HSE officer responsible for that driver.
                    </li>
                    <li className="list-group-item px-0">
                      <i className="bi bi-5-circle text-primary me-2"></i>
                      Events are logged per driver and per journey, building a record for coaching and HSE reporting.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default JMS;
